import { NEQ } from 'framework-listing-lib/utils/filters';
import http from 'hub-http/clients/apiClient';
const API_BASE = '/crm-search';
export const USER_OBJECT_TYPE_ID = '0-115';
export const JITA_PROPERTY = 'hs_hubspot_jita_user';
export const IS_BOT_PROPERTY = 'hs_is_bot';
export const IS_VIRTUAL_USER = 'hs_is_mam_user';
export const IS_APP_SERVICE_ACCOUNT = 'hs_is_app_service_account';
export const IS_WORK_AGENT = 'hs_is_work_agent';
export const HS_HIDDEN_PROPERTY = 'hs_hidden';
export const USER_ID_PROPERTY = 'hs_internal_user_id';
export const NAME_PROPERTY = 'hs_searchable_calculated_name';
export const EMAIL_PROPERTY = 'hs_email';
export const DEACTIVATED_PROPERTY = 'hs_deactivated';
export const SEAT_PROPERTY = 'hs_assigned_seats';
export const PERMISSION_SET_PROPERTY = 'hs_assigned_permission_sets';
export const ACCESS_PROPERTY = 'hs_access';
export const defaultFilters = [NEQ(JITA_PROPERTY, 'true'), NEQ(IS_BOT_PROPERTY, 'true'), NEQ(IS_VIRTUAL_USER, 'true'), NEQ(IS_APP_SERVICE_ACCOUNT, 'true'), NEQ(IS_WORK_AGENT, 'true'), NEQ(HS_HIDDEN_PROPERTY, 'true')];
export const getDefaultFilters = excludeInactiveUsers => {
  return excludeInactiveUsers ? [...defaultFilters, NEQ(DEACTIVATED_PROPERTY, 'true')] : defaultFilters;
};
export const getDefaultFilterGroups = excludeInactiveUsers => {
  return [{
    filters: getDefaultFilters(excludeInactiveUsers)
  }];
};
export default class CrmSearchAPI {
  static search(data) {
    return http.post(`${API_BASE}/search`, {
      data
    });
  }
}